export default "__VITE_ASSET__C0B$LHMG__"